import React from 'react';
import EzThemeProviderMui from './Implementations/EzThemeProviderMui';
var EzThemeProvider = function EzThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return React.createElement(EzThemeProviderMui, {
    theme: theme
  }, children);
};
export default EzThemeProvider;